import React, { useEffect } from "react"

function Restringido() {

  useEffect(() => {


  }, []);


  return (
    // Mantenemos el contenedor flex para centrar horizontalmente, pero ajustamos la alineación vertical.
    <div className="container d-flex justify-content-center align-items-start vh-100">
      {/* Añadimos un margen superior (mt-5) para empujar el cuadro hacia abajo un poco desde arriba.
            Si quieres que esté más arriba del centro, podríamos jugar con mt-3 o incluso menos.
            'align-items-start' ahora permite que 'mt-5' tenga efecto desde la parte superior. */}
      <div className="card text-center shadow p-4 bg-white rounded mt-5"> {/* Eliminamos mb-5 y agregamos mt-5 */}
        <div className="card-body">
          <i className="fa fa-exclamation-triangle fa-3x text-danger mb-3" aria-hidden="true"></i>

          <h1 className="card-title text-danger display-4">Acceso Restringido</h1>

          <p className="card-text lead mt-3">
            No tienes permiso para ver esta página.
          </p>

          {/* Hemos eliminado completamente el botón */}
        </div>
      </div>
    </div>
  );
}

export default Restringido;